<template>
    <div class="card border-light borda-redonda sombra">
        <div class="card-body">
            <h6 class="card-title text-center">
                O prestador chegou ao local?
            </h6>
            <div class="card-text">
                <div class="col-12 mb-3 lh-18">
                    <small>
                        Confirme a chegada do prestador.
                    </small>
                </div>
                <div class="col-12 p-0 text-center">
                    <button type="button"
                        class="btn btn-success"
                        @click="marcarChegada()"
                        :disabled="loading"
                    >
                        {{ loading ? `Aguarde ...` : `Confirmar` }}
                        <span class="material-symbols-outlined">check</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script setup>
import { defineProps, ref } from 'vue';
import { useAtendimentoStore } from '@/stores/atendimento';
import moment from 'moment';
import { toast, alert, confirm } from '@/helper/alerts';

const props = defineProps({
    idServicoAtendimento: String,
});

const store = useAtendimentoStore();
const loading = ref(false);

function marcarChegada() {
    confirm(
        "",
        "Tem certeza que deseja informar à assistência que prestador chegou ao seu local para realizar o atendimento?",
        async () => {
            loading.value = true;
            try {
                const response = await store.marcarChegadaPrestador(props.idServicoAtendimento, moment().format("DD/MM/YYYY HH:mm:ss"));
                toast(response.error ? "error" : "success", response.message);
            } catch (error) {
                alert("error", "", error.message);
            } finally {
                loading.value = false;
            }
        }
    );
}
</script>
